export const landing_data = {
  'medical-fundraising': {
    section_1: {
      header: 'Start a FREE Medical Fundraiser & Raise Funds for Medical Treatments',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image: '/assets/images/medical-landing/banner-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel1.jpg',
          text: 'Dhiraj (Aarohi’s father) raised ₹ 25,00,000 for Aarohi’s Cancer Treatment in Just 20 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel2.jpg',
          text: 'Rajshekhar Nadar (Karthi\'s father) raised ₹ 25,85,870 for Karthi\'s Liver Transplantation in just 4 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel3.jpg',
          text: 'Purvi (Pushpesh\'s friend) raised ₹ 23,78,790 for Pushpesh\'s  Cancer treatment in just 26 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel4.jpg',
          text: 'Pravin raised ₹ 25,10,000 for his Liver Transplant in just 7 days',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What medical treatments can you raise funds for?',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'heart-surg',
          text: 'Open Heart Surgery',
          invertText: ' ₹6.2 Cr raised by 21 people for their/loved one\'s Open Heart Surgery.',
          text_desc: 'In case of coronary diseases or a malfunctioning heart, opt for corrective heart surgeries by raising funds online for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'kidney-tran',
          text: 'Kidney Transplant',
          invertText: ' ₹8.6 Cr raised by 35 people for their/loved one\'s Kidney Transplant.',
          text_desc: 'In case of kidney failure, you can support the dialysis or transplant by raising funds online for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'nicu',
          text: 'NICU Care',
          invertText: ' ₹10.7 Cr raised by 52 parents for the treatment of under - developed organs of their babies.',
          text_desc: 'Premature babies battle multiple complications due to extremely underdeveloped organs. Pay for the cost of their treatment by raising funds online',
          link: 'Know More',
        },
        {
          icon: 'bone-marrow',
          text: 'Bone Marrow Transplant',
          invertText: ' ₹8.6 Cr raised by 35 people for their/loved one\'s Bone Marrow Transplant.',
          text_desc: 'Once you have a suitable bone marrow contributor, raise funds for the life-saving bone marrow transplant surgery for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'cancer-trt',
          text: 'Cancer Treatment',
          invertText: ' ₹32 Cr raised by 103 people for their/loved one\'s Cancer Treatment.',
          text_desc: 'This five lettered disease comes with chemotherapy, radiation and other expensive treatment options. Support your battle against cancer by raising funds online',
          link: 'Know More',
        },
        {
          icon: 'other',
          text: 'Any other disease?',
          invertText: '',
          text_desc: 'Call Us',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: 'Why are people choosing medical crowdfunding?',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'High cost of treatment',
          text_desc: 'Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small contributions from a large group of people.',
        },
        {
          icon_class: 'asking-money',
          text: 'Asking For Money Isn’t Easy',
          text_desc: 'When in need, asking for help from people and describing financial problems face-to-face can be awkward and inconvenient. Online crowdfunding makes the process of asking for money easier and way more seamless.',
        },
        {
          icon_class: 'emergencies',
          text: 'Emergencies Demand a Prompt Response',
          text_desc: 'When your loved ones are diagnosed with life threatening diseases, it’s overwhelming emotionally as well as financially. Most medical emergencies require the treatment to start at the earliest. By giving you a platform to share your emergency, online crowdfunding helps you gather funds quickly.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Loan Repayment Is Stressful',
          text_desc: 'Getting drowned in personal loans is very common in times of medical emergencies. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding comes without debts.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from people like you',
      sub_header: 'who benefited from medical crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'I want to start a medical fundraiser. What all do i need?',
          answer: 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.',
        },
        {
          question: 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
          answer: 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.',
        },
        {
          question: 'I want to start raising funds, how do I start a fundraiser on Ketto?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Medical Fundraising & Crowdfunding',
      subheader: 'Online Medical crowdfunding is an alternative method for individuals and organisations to generate funds required for costly medical treatments like open-heart surgeries, NICU care, bone marrow transplant, cancer treatments and any other disease',
      details: [
        {
          h2: 'Medical Bills are a Burden for Many Individuals and Families',
          desc: 'Expenses related to hospital stays, cancer treatments with high- cost chemotherapy routines, and other medicinal costs can be even higher. Treatment costs and necessary living expenses can bring the best of families to the brink of experiencing hard times. Insurance plans are not enough, as policies do not cover everything you need.',
          img_src: '/assets/images/medical-landing/medicalbills.png'
        },
        {
          h2: 'Try Medical Crowdfunding',
          desc: 'Stop worrying about rising medical bills, or debts and start a medical fundraising campaign with Ketto. Ketto is a Crowdfunding Platform based out of India. Crowdfunding is the easiest way to avail support from friends, family and numerous individuals who are waiting to contribute funds.',
          img_src: '/assets/images/medical-landing/trymedical.png'
        },
        {
          h2: 'Start a Medical Fundraiser for Yourself or a Loved One',
          desc: 'With Ketto, you can start a free, easy fundraiser in minutes to cover medical bills and healthcare costs. You can also take on the role of spreading the word and bring in funds when a close friend is diagnosed with unexpected illnesses. Medical fundraising campaigns can give your well-wishers a way to express support when needed.',
          img_src: '/assets/images/medical-landing/startMedFundraiser.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'medical',
    metaTitle: 'Medical Fundraising: Get Financial Help for Medical Treatments in India',
    metaDesc: 'Start a FREE Medical Crowdfunding campaign with Ketto! Raise funds to get financial help for your high-cost medical treatments in India.',
    keywords: ''
  },
  'memorial-fundraising': {
    section_1: {
      header: 'Support a Grieving Family with Memorial Fundraising',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image: '/assets/images/medical-landing/memorial-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel5.png',
          text: 'Saurabh’s unexpected demise has left the family and future of two kids in the unknown. Priya M has decided to raise funds to support Saurabh Bansal\'s family.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel6.png',
          text: 'Jitendar Guglani, passed away due to a sudden drop in blood pressure. His close friends and colleagues are raising funds to support his grieving family.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel7.png',
          text: 'Narottam Kumar passed away due to covid, His batch mates have started to raise funds to help his 7-year-old son and wife who is a homemaker.'
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel8.png',
          text: 'Sudeeksha, advocated for VOW, "Voice For Women", an initiative fighting sexual harassment lost her life in a bike accident, Ishaani is collecting funds to support the family.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'On Ketto\'s memorial fundraising platform, loved ones can raise money to help cover the costs of all expenses related to the funeral and survival of the deceased’s kin such as:',
      sub_header: '',
      bg_image: '',
      desc: 'Setting up a memorial fundraiser on Ketto is simple. Just log in to our website and click start a memorial fundraising campaign. Add a few details and mentioning your needs, and once verification is complete, use our simplified tools to share the campaign link with your friends, family and social network. You start receiving contributions immediately and directly to your account. Our memorial fundraising allows users to raise money free of charge through verified payment gateway providers. We want to help-people-help-others, especially during their times of need and loss. Our goal is to simplify the process during these situations when giving is of most importance. Start your memorial funding campaign on Ketto today.',
      data_list: [
        {
          text: 'Child’s Education Expenses',
          icon: 'child-edu-exp',
        },
        {
          text: 'Household Expenses',
          icon: 'household-exp',
        },
        {
          text: 'Funds to Meet Family Daily Needs',
          icon: 'funds-family-exp',
        },
        {
          text: 'Medical Expenses of Family Members',
          icon: 'med-family-exp',
        },
        {
          text: 'Transfer cost Of Legal Succession',
          icon: 'transfer-cost-exp'
        }
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: 'Why are people choosing medical crowdfunding?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'High cost of treatment',
          text_desc: 'Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small contributions from a large group of people.',
        },
        {
          icon_class: 'asking-money',
          text: 'Asking For Money Isn’t Easy',
          text_desc: 'When in need, asking for help from people and describing financial problems face-to-face can be awkward and inconvenient. Online crowdfunding makes the process of asking for money easier and way more seamless.',
        },
        {
          icon_class: 'emergencies',
          text: 'Emergencies Demand a Prompt Response',
          text_desc: 'When your loved ones are diagnosed with life threatening diseases, it’s overwhelming emotionally as well as financially. Most medical emergencies require the treatment to start at the earliest. By giving you a platform to share your emergency, online crowdfunding helps you gather funds quickly.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Loan Repayment Is Stressful',
          text_desc: 'Getting drowned in personal loans is very common in times of medical emergencies. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding comes without debts.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from people like you',
      sub_header: 'who benefited from medical crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'I want to start a medical fundraiser. What all do i need?',
          answer: 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.',
        },
        {
          question: 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
          answer: 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.',
        },
        {
          question: 'I want to start raising funds, how do I start a fundraiser on Ketto?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image: 'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Raise Memorial Funds',
      subheader: '',
      details: [
        {
          h2: 'Get support & cope with the loss of loved ones',
          desc: 'Memorial fundraising lets patrons, family and community come together to help their friends and loved ones when needed. A memorial fund on Ketto\'s online crowdfunding platform is a convenient way to help pay expensive funeral costs or honour the life and memory of a beloved individual.',
          img_src: '/assets/images/medical-landing/get_support.png'
        },
        {
          h2: 'Try Medical Crowdfunding',
          desc: 'Funeral costs can weigh down on any family and always comes as a surprise. Most individuals are unaware of the various expenses connected with burials and memorial services. The costs of a funeral today average anywhere between INR7,000 and INR15,000. These expenses add a burden on a grieving family, primarily if they haven\'t earlier intended to pay for a funeral.',
          img_src: '/assets/images/medical-landing/trymemorial.png'
        },
        {
          h2: 'Start a fundraiser for your loved one',
          desc: 'Our goal at ketto is to provide a contribution and fundraising platform where loved ones can help the grieving family manage various expenses and provide assistance that will cherish the remembrance of the deceased. Ketto has simplified the process to help reduce the financial costs of planning memorial services and funerals.',
          img_src: '/assets/images/medical-landing/lovedones.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'memeorial',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'memorial',
    metaTitle: 'Memorial Fundraising - Raise Memorial Funds On Ketto',
    metaDesc: 'Start a memorial fundraiser for your near and dear ones on Ketto. Memorial crowdfunding is the best way to help grieving families to manage various expenses and funeral expenses.'
  },
  'help-children': {
    section_1: {
      header: 'Fundraising for Child Welfare Support',
      bg_image: '/assets/images/medical-landing/banner-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/images/carousel4.jpg',
          text: 'Manish (Teacher at SHA) raised ₹5,66,598 for Sikkim Himalayan Academy School in just 19 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/images/carousel1.jpg',
          text: 'Shuvajit (Supporter of Barefoot  NGO) raised ₹4,65,947 to help them continue night schooling.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/images/carousel2.jpg',
          text: 'Anjali raised ₹4,54,125 to provide home for orphans and underprivileged teens in just 36 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/images/carousel3.jpg',
          text: 'The NGO “Underprivileged Advancement by Youth” raised ₹4,47,251 to provide education to 1500 children.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What can you raise funds for?',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          icon: 'paying',
          text: `Child’s Medical Treatments`
        },
        {
          icon: 'child-edu',
          text: 'Child Education',
        },
        {
          icon: 'sponsoring',
          text: 'Sponsors Healthy Meals to Children'
        },
        {
          icon: 'child-athletes',
          text: 'Supports Child Athletes'
        },
        {
          icon: 'become-ngo',
          text: 'Become a Champion for an NGO'
        }
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: `Here’s why you should choose Kettos online crowdfunding platform to raise funds for child welfare!`,
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'ailing-child',
          text: 'Start a crowdfunding Campaign',
          text_desc: 'You can start a crowdfunding campaign for child Welfare, contribution for children, children fund on Ketto’s platform within minutes for free and quickly raise funds at your fingertips with the help of a few clicks.',
        },
        {
          icon_class: 'privilages',
          text: '24*7 Support',
          text_desc: `We offer you 24*7 assistance from dedicated fundraiser managers throughout your fundraising journey via call, WhatsApp, email, SMS and our Instant Chatting Interface`,
        },
        {
          icon_class: 'deserving',
          text: 'Withdraw Funds',
          text_desc: 'The funds raised can be withdrawn without any hassle directly to your bank account and you can withdraw it at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'champ-ngo',
          text: 'Becoming A Champion For NGOs',
          text_desc: 'Crowdfunding is the most convenient way to support initiatives of NGOs that look after the needs of children that require help and support.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'What campaigners have to say',
      sub_header: '',
      bg_image: 'children-bg',
      data_images: [
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) raised ₹25,85,870',
          facebook: '',
          whatsapp: '9833689485',
          phone: '9833689485',
          text: 'My Karthi got his operation only because of people who helped me raise Rs. 25 lakh without any expectations. My son is going to live in the name of people who contributed.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'dhruv',
          title: 'Dhruv Pandey (for ‘Just for Kicks’) Raised ₹6,5,0000',
          facebook: 'https://www.facebook.com/dhruv.pandey.169',
          whatsapp: '8588999023',
          phone: '8588999023',
          text: 'I could raise Rs. 6.5 lakh to take the ‘Just For Kicks’ program to 100 girls in Dharwad. Ketto worked wonderfully as a platform. I used the tools to reach out to the contributors & post updates. Our contributors found the payment gateway safe & user friendly. All in all, a great experience!',
          blog: 'http://blog.ketto.org/help-me-empower-underprivileged-girl-children/',
        },
        {
          profile: 'nagarkarthik',
          title: 'NagarKarthik (for ‘Haji Public School’ ) Raised ₹9,31,000',
          facebook: 'https://www.facebook.com/nagakarthik',
          whatsapp: '9480000089',
          phone: '9480000089',
          text: 'Ketto as a platform and a tool has been instrumental in helping us raise Rs.9,31,000 for our social initiative and reach out to a large audience. Choosing Ketto to go the crowd was the right decision we made.',
          blog: 'http://blog.ketto.org/help-haji-public-school-get-a-reliable-solar-grid/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'Which causes can I raise funds for?',
          answer: 'You can raise funds for sponsoring meals, education, sports training, sanitation or any other cause that promises to bring about a positive change in a child’s life.',
        },
        {
          question: 'Can I raise funds for any orphan/street child?',
          // tslint:disable-next-line: max-line-length
          answer: 'Absolutely! Just zero down on a cause, write a compelling a story about why the child needs help and start a fundraiser.',
        },
        {
          question: 'I don\'t have any NGO but I want to feed poor children this Diwali.',
          answer: 'That’s a lovely thought! You can choose an NGO that works towards this cause and start a fundraiser for them.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know people who are always trying their best to help animals around them? We\'re sure you have at least one on your list - share it with them!',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers',
      sub_header: '',
      bg_image:
        'child-offer-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Raise funds to help children!',
      subheader: '',
      details: [
        {
          h2: 'Keeping children healthy',
          desc: `Children are God’s gift to us and are looked upon as a blessing! Keeping children healthy, safe and well provided for is a cause to which we can all unite and help selflessly. After all, there's nothing more rewarding than helping the little ones we care for. Hence, crowdfunding for child welfare and contribution for children fund is so authoritative and powerful with Ketto’s online crowdfunding platform. `,
          img_src: '/assets/images/medical-landing/keepchildhealthy.png'
        },
        {
          h2: 'Survey Report',
          desc: `A survey done by the Child Rights and You (CRY) census report says, 1 out of 4 children don't receive schooling, more than 19 million are malnourished, 10 million are oppressed through child labour, and more than 11 million are on the streets. Crowdfunding online using Ketto’s online crowdfunding platform can be the change and make a huge impact to reduce these numbers. By fundraising online, you can quickly raise money online from contributors, supporters and well-wishers to offer a child an inspiring living.`,
          img_src: '/assets/images/medical-landing/surveyreport.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'children',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/children/images/children_sprite.png\')',
    cause: 'children',
    metaTitle: 'Child Welfare - Girl Education, Meals & Medical Funding | Ketto',
    metaDesc: 'Support child welfare, girl child education, daily meals and medical treatments by starting a crowdfunding campaign on Ketto. Remember, children are our nations future, and they hold the key to a better tomorrow!'
  },
  'creative-fundraising': {
    section_1: {
      header: 'Raise Funds For Your Creative & Entrepreneurial Project',
      sub_header: 'Need Funds For Your Creative & Entrepreneurial Project?',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/design/pattern.png\') center center/cover no-repeat fixed',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/images/entre1.jpg',
          text: 'Leaf Wearables raised ₹ 5,16,670 for \'SAFER - smart jewellery\' in just 27 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/images/entre2.jpg',
          text: 'Saurabh Bodas raised ₹ 5,08,675 for their technology platform \'OpinionX\' in just 19 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/images/entre5.jpg',
          text: 'Team Hyperloop India raised ₹ 35,81,870 to help Team India build their first Hyperloop for SpaceX Hyperloop competition in just 29 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/images/entre4.jpg',
          text: 'Omaggio raised ₹ 5,00,000 for Jalika Dance Theatre Production in just 9 days',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What can you raise funds for?',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          icon: 'innovative-idea',
          text: 'Innovative Idea',
          invertText: ' 8.2 Cr raised by 51 people to convert their Innovative Idea into a reality',
          text_desc: 'Change the way the world thinks by raising funds for your game-changing design, product or technological idea.',
          link: 'Know More',
        },
        {
          icon: 'film',
          text: 'Films & Documentaries',
          invertText: ' 3.6 Cr raised by 37 people to create Films & Documentaries',
          text_desc: 'Raise funds for the equipment, crew or travelling required to bring your masterpiece to life.',
          link: 'Know More',
        },
        {
          icon: 'theatre',
          text: 'Theatre',
          invertText: ' 6.7 Cr raised by 44 people for Theatre, Art and Dance.',
          text_desc: 'Bring powerful stories alive on the stage by funding your production - from props, costumes to the cast and director’s fee.',
          link: 'Know More',
        },
        {
          icon: 'book-publishing',
          text: 'Book Publishing',
          invertText: ' 2.5 Cr raised by 21 people for publishing their book.',
          text_desc: 'If you’re looking to publish a book, raise funds for everything from editing and cover design to setting up your author website, and marketing your book.',
          link: 'Know More',
        },
        {
          icon: 'music',
          text: 'Music',
          invertText: ' 5.1 Cr raised by 49 people for their Music Production and Publication.',
          text_desc: 'Floor the world with your music and compositions by raising funds for its creation.',
          link: 'Know More',
        },
        {
          icon: 'other',
          text: 'Any other reason?',
          invertText: '',
          text_desc: 'Call Us',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: 'Why are entrepreneurs choosing crowdfunding?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/design/pattern.png\') center center/cover no-repeat fixed',
      data_images: [
        {
          icon_class: 'testing-idea',
          text: 'Testing your Idea',
          text_desc: 'Before launching your big idea in the market, crowdfunding is the perfect way to test the waters and find out what people really think about your idea.',
        },
        {
          icon_class: 'pre-selling',
          text: 'Pre-Selling',
          text_desc: 'You can sell your product directly to your consumers by allowing people to pre-order it.',
        },
        {
          icon_class: 'get-funds',
          text: 'Easy way to get funds',
          text_desc: 'If your idea strikes a chord with people, crowdfunding is the best and the fastest way to raise funds to take it to the next level.',
        },
        {
          icon_class: 'pitch-consumer',
          text: 'Pitch directly to consumers',
          text_desc: `Instead of pitching your ideas to investors and hoping for a positive response,
            you can take your idea to the target audience.`,
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from successful entrepreneurs',
      sub_header: '',
      bg_image:
        'creative-bg',
      data_images: [
        {
          profile: 'saurabh',
          title: 'Saurabh Bodas',
          facebook: 'https://www.facebook.com/scbodas',
          whatsapp: '',
          phone: '',
          text: 'I want to thank you (Ketto) for creating such an amazing platform which has capability to help entrepreneurs like me to take their product to next level. Thank you for helping me & supporting me during the entire process right from the very first discussion regarding my idea till the last amount of payout got credited.',
          blog: 'http://blog.ketto.org/opinionx-the-most-accurate-second-opinion/',
        },
        {
          profile: 'ayush',
          title: 'Ayush Sinha',
          facebook: 'https://www.facebook.com/SolarMobilMIT/',
          whatsapp: '',
          phone: '',
          text: 'Dreams do come true with Ketto. We thank the entire Ketto team for providing a wonderful platform for young innovators like us, and the all the support & guidance throughout the process. Choosing Ketto as a platform helped us achieve our objective, and we have had a fulfilling and enriching experience.',
          blog: 'http://blog.ketto.org/help-us-revolutionize-indian-transportation/',
        },
        {
          profile: 'pradnya',
          title: 'Pragnya Wakhlu',
          facebook: 'https://www.facebook.com/pragnya.wakhlu',
          whatsapp: '',
          phone: '',
          text: 'We successfully met our crowdfunding goal and managed to raise upto 115% of our target! My manager went out of her way to work with me to come up with a strategy for raising funds. A few things I liked about Ketto is the systematic approach to crowdfunding by which a newbie (like me) was able to understand what works.',
          blog: 'http://blog.ketto.org/kahwa-speaks/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/design/pattern.png\') center center/cover no-repeat fixed',
      faqs1: [
        {
          question: 'Can I raise funds at the first stage of my business/for my idea/as initial commencement funds?',
          answer: 'Absolutely! Just make sure your potential supporters know all details they need to understand your idea.',
        },
        {
          question: 'Do I have to repay my supporters?',
          answer: 'No at all. You can repay your supporters by posting a heartfelt thank you, rewards and regular updates about the progress of your fundraiser.',
        },
      ],
      faqs2: [
        {
          question: 'Will I get any help to understand how to go about the fundraiser?',
          answer: `Yes. A dedicated campaign manager will help you with the launch,
            pre launch and post launch strategy throughout your campaign.`,
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers',
      sub_header: '',
      bg_image:
        'creative-offer-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free',
        },
        {
          icon_class: 'offer-icon',
          text: 'We offer you 24*7 assistance from dedicated fundraiser managers throughout your fundraising journey via call, WhatsApp, email, SMS and our Instant Chatting Interface',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'This is your money, you can withdraw it at any point during the course of your fundraiser',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress via instant alerts, email and track each and everything from a real-time dashboard ',
        },
        {
          icon_class: 'credit-icon',
          text: 'We accept contributions through all online transaction modes like credit card, debit card netbanking and payment wallets',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    formData: {
      header: 'Need Funds For Your Creative & Entrepreneurial Project?',
      sub_header: 'Let’s turn that innovative project that you’ve been dreaming of, into reality.',
    },
    pageType: 'creative',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/entrepreneur/images/entrepreneur_sprite.png\')',
    cause: 'creative',
    metaTitle: 'Creative Crowdfunding – Raise Funds for Creative & Entrepreneurial Projects',
    metaDesc: 'Creative crowdfunding can help raise funds for creative projects such movies, music, theatre plays and and entrepreneurs to fund their startup. Visit Ketto.org to start your campaign today!'
  },
  'cancer-crowdfunding': {
    section_1: {
      header: 'Start a FREE Cancer Fundraiser to Get Funding for Cancer Treatment',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image:
        '/assets/images/medical-landing/banner-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel1.jpg',
          text: 'Dhiraj (Aarohi’s father) raised ₹ 25,00,000 for Aarohi’s Cancer Treatment in Just 20 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel2.jpg',
          text: 'Rajshekhar Nadar (Karthi\'s father) raised ₹ 25,85,870 for Karthi\'s Liver Transplantation in just 4 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel3.jpg',
          text: 'Purvi (Pushpesh\'s friend) raised ₹ 23,78,790 for Pushpesh\'s  Cancer treatment in just 26 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel4.jpg',
          text: 'Pravin raised ₹ 25,10,000 for his Liver Transplant in just 7 days',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'Different types of Cancers that you can raise funds for on Ketto',
      sub_header: 'You can Raise Money For Cancer Treatments Costs which includes Chemotherapy, Medicines, Light Therapy etc. Below are some of the major Cancers for which you can raise funds for:',
      bg_image: '',
      data_images: [
        {
          icon: 'lukemia',
          text: 'Leukemia And Lymphoma',
        },
        {
          icon: 'lung-cancer',
          text: 'Lung Cancer',
        },
        {
          icon: 'prostate-cancer',
          text: 'Prostate Cancer',
        },
        // {
        //   icon: 'oral-cancer',
        //   text: 'Oral Cancer',
        // },
        // {
        //   icon: 'melanoma',
        //   text: 'Melanoma',
        // },
        {
          icon: 'kidney-cancer',
          text: 'Kidney Cancer',
        },
        {
          icon: 'breast-cancer',
          text: 'Breast Cancer',
        },
        {
          icon: 'throat-cancer',
          text: 'Throat Cancer',
        },
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: 'Why are people choosing cancer crowdfunding?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'High cost of treatment',
          text_desc: 'Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small contributions from a large group of people.',
        },
        {
          icon_class: 'asking-money',
          text: 'Asking For Money Isn’t Easy',
          text_desc: 'When in need, asking for help from people and describing financial problems face-to-face can be awkward and inconvenient. Online crowdfunding makes the process of asking for money easier and way more seamless.',
        },
        {
          icon_class: 'emergencies',
          text: 'Emergencies Demand a Prompt Response',
          text_desc: 'When your loved ones are diagnosed with life threatening diseases, it’s overwhelming emotionally as well as financially. Most medical emergencies require the treatment to start at the earliest. By giving you a platform to share your emergency, online crowdfunding helps you gather funds quickly.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Loan Repayment Is Stressful',
          text_desc: 'Getting drowned in personal loans is very common in times of medical emergencies. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding comes without debts.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from people like you',
      sub_header: 'who benefited from medical crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'I want to start a medical fundraiser. What all do i need?',
          answer: 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.',
        },
        {
          question: 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
          answer: 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.',
        },
        {
          question: 'I want to start raising funds, how do I start a fundraiser on Ketto?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'What is Cancer Crowdfunding?',
      subheader: 'Online cancer crowdfunding campaigns that seek small monetary contributions to help an individual or family cover expensive cancer treatments and chemotherapy is called cancer crowdfunding. Crowdfunding to raise funds for cancer treatment expense and chemotherapy drugs is the most cost-effective and easy way to begin. You can start an individual cancer fundraising campaign or begin raising funds for a nonprofit that serves individuals affected by cancer.',
      details: [
        {
          h2: 'How does cancer crowdfunding work?',
          desc: 'Using Ketto’s online crowdfunding platform individuals, families and friends of cancer patients can start a “ZERO PERCENT PLATFORM FEE” free online cancer crowdfunding and cancer fundraising campaign to raise funds and pay for high cancer bills, cancer treatments and expensive chemotherapy drugs, treatments and procedures. It’s effortless to start your cancer fundraising campaign. Log in on the online crowdfunding platform, select start a new campaign, set a fundraising goal, fill in few mandatory details, create your crowdfunding campaign page, and promote your campaign.',
          img_src: '/assets/images/cancer-crowdfunding/howcancercfworks.png'
        },
        {
          h2: 'Diagnosed with Cancer?',
          desc: 'You can speak to a hundred different people and get a hundred different answers related to cancer and factors that cause cancer. At its most basic, cancer is a malfunction of genes within cells of our body that causes cells to grow and divide uncontrollably—or prevent them from deteriorating when they should. These abnormal cells become cancerous and cause cancer.',
          img_src: '/assets/images/cancer-crowdfunding/diagnosedcancer.png'
        },
        {
          h2: 'How can Ketto help you To Fund Your Cancer Treatment?',
          desc: 'You can start a cancer crowdfunding campaign for free on Ketto & raise funds to pay for your or a close relative and friends cancer treatments and cancer-related medical bills.',
          img_src: '/assets/images/cancer-crowdfunding/kettocancernew.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header:
        'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'health',
    metaTitle: 'Fundraising for Cancer: Get Financial Help for Cancer Patients',
    metaDesc: 'Start FREE Cancer Crowdfunding campaign with Ketto! Get financial support for cancer patients in India to fund their treatments.',
    keywords: 'Cancer Crowdfunding, Financial Help for Cancer Patients'
  },
  'fundraising-for-education': {
    section_1: {
      header: 'Crowdfunding for Education Made Easy with Ketto',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image:
        '/assets/images/medical-landing/banner-bg-ed.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: '/assets/images/carousel-1.png',
          text: 'Vartika Agarwal raised ₹ 22,79,117 for her 2.5 years old son\'s education in just 57 days.',
        },
        {
          url: '/assets/images/carousel-2.png',
          text: 'Bagyalakshmi (Joses\'s Aunt) raised ₹ 26,00,845 for Joses\'s Education in just 21 days.',
        },
        {
          url: '/assets/images/carousel-3.png',
          text: 'Vijayaraghavan raised ₹ 31,46,770 for a Sanskrit School, Melukote in just 139 days.',
        },
        {
          url: '/assets/images/carousel-4.png',
          text: 'Vishwas (Amit\'s Friend) raised ₹ 22,26,544 for Amit\'s Kids Education in just 26 days.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'Families, students, teachers, administrative staff can raise funds and start an Education Crowdfunding Campaign for:',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'public-schools',
          text: 'PUBLIC SCHOOLS',
          invertText: 'Start crowdfunding for public schools to raise funds from like-minded students, generous parents, teachers and the local community!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'edu-associate',
          text: 'EDUCATIONAL ASSOCIATIONS',
          invertText: 'Raise money to assist the financial needs of your educational clubs and associations.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'after-school-pgm',
          text: 'AFTER-SCHOOL PROGRAMS',
          invertText: 'Help your after-school program and keep it going by starting a crowdfunding campaign with Ketto.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'parent-teacher',
          text: 'PTA (PARENT-TEACHER ASSOCIATIONS)',
          invertText: 'Try Ketto crowdfunding! Start a crowdfunding campaign for PTA and request contributions from friends and family!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'extracurricular',
          text: 'EXTRACURRICULAR PROGRAMS',
          invertText: 'Start raising more money for extracurricular activities through education crowdfunding today!',
          text_desc: '',
          link: 'Know More',
        },
      ],
      class: 'educational',
      style: '',
    },
    section_3: {
      header: 'Why is Ketto India’s Most Promising Online Crowdfunding Platform to Raise Funds for Education?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'Payout',
          text_desc: 'You shouldn’t have to wait to get your funds. Ketto ensures you can withdraw funds collected at any point during the progress of your fundraiser.',
        },
        {
          icon_class: 'asking-money-ed',
          text: 'International Payment Support',
          text_desc: 'Reach out to like-minded students and peers abroad. At Ketto, contributions are accepted in multiple currencies from around the world.',
        },
        {
          icon_class: 'emergencies',
          text: '24*7 Support',
          text_desc: '24*7 on-call assistance, WhatsApp, Email, SMS and Personalised Instant Chatting Interface.',
        },
        {
          icon_class: 'loan-repayment-ed',
          text: 'Dedicated Fundraiser Expert',
          text_desc: 'A dedicated fundraiser expert is appointed; they will guide you through your fundraising journey and assist you with all your fundraising queries.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Millions of people have successfully raised funds on Ketto for their cause.',
      sub_header: 'Hear what some of our successful campaigners have to say!',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: ' How I can start Education Crowdfunding?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes, and signing up is free*. Just sign up, fill in details of what you need money for and hit submit.',
        },
        {
          question: 'What all documents do I need to submit?',
          answer: 'All campaigners undergo a KYC verification based on the submitted legal identity proofs and other supporting documents. PAN card Address proof - Aadhar card (front and back) or Passport (first and last page) or Election card (front and back), or Driver\'s license.',
        },
        {
          question: 'How much I can raise for my education?',
          answer: 'You can reach out to our support team to get advice on much you should raise for your education.',
        },
        {
          question: 'Can I raise funds for Overseas Universities Education?',
          answer: 'Yes! You can raise funds to pay for your education in overseas universities.',
        },
        {
          question: 'What is the withdrawal process?',
          answer: 'To withdraw funds in your bank account, you need to submit your bank account details and documents per Ketto\'s requirements.',
        },
        {
          question: 'I have more questions regarding fundraising for education; whom do I write to?',
          answer: 'You can write to info@ketto.org. Just drop your queries and get answers to your doubts. ',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Does Crowdfunding for Education on Ketto Offer?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: '0% Platform Fee*. Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'amt-raised-ed',
          text: 'Amount raised after the transactional processing fee is yours to keep.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accept contributions from all cards, net banking, UPI and online wallets from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'Instantly Withdraw Of Funds without any hassle directly to your bank account.',
        },
        {
          icon_class: 'multiple-ed',
          text: 'Multiple people can manage and fundraise for your cause.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Receive instant updates of fundraiser\'s progress on a real-time dashboard.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Crowdfunding for Education',
      subheader: 'The term “Education Crowdfunding” defines itself as a process of raising money by seeking small contributions from several people towards an education-related cause.',
      details: [
        {
          h2: 'What is Education Crowdfunding in India?',
          desc: 'Education Crowdfunding helps teachers, students and NGOs raise funds to buy classroom supplies, take children on special field trips and build toilets. Crowdfunding can also provide funds for distributing daily meals, upgrade school infrastructures like gymnasium, play areas, classroom renovation and expansion. Online crowdfunding for education is gaining more and more recognition. It is safe, easy and effective, and can reach a much larger pool of people in far less time.',
          img_src: '/assets/images/education-fundraising/img-1.png'
        },
        {
          h2: 'Why Start an Education Fundraiser with Ketto?',
          desc: 'Education Crowdfunding on Ketto’s online crowdfunding platform is Effective, Swift and Simple. Education Crowdfunding is also the most economical medium to raise funds for education funding campaigns.',
          img_src: '/assets/images/education-fundraising/img-2.png'
        },
        {
          h2: 'Who can Start An Education Crowdfunding Campaign on Ketto?',
          desc: 'Students can Start An Education Fundraising Campaign for themself or provide support to a friend’s education campaign. Parents can Start An Education Crowdfunding Campaign for their Child\'s Future Education. Similarly, you can fundraise for education-related causes or collaborate with NGOs that improve the education quality provided in rural schools. The education crowdfunding platform of Ketto offers a fast campaign startup for students, teachers, NGOs and organisations looking to crowdfund for education projects in India and around the world.',
          img_src: '/assets/images/education-fundraising/img-3.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header:
        'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'education',
    metaTitle: 'Fundraising for Education - Raise Funds for Education in India',
    metaDesc: 'Start an education fundraising campaign with Ketto! Achieve your academic goals with crowdfunding campaign and raise funds for your education.',
    keywords: 'crowdfunding for education, education fundraising'
  },
  'hospital': {
    section_1: {
      header: 'Medical Crowdfunding is the Best Way to Raise Money for Medical Expenses',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image:
        '/assets/images/medical-landing/banner-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel1.jpg',
          text: 'Dhiraj (Aarohi’s father) raised ₹ 25,00,000 for Aarohi’s Cancer Treatment in Just 20 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel2.jpg',
          text: 'Rajshekhar Nadar (Karthi\'s father) raised ₹ 25,85,870 for Karthi\'s Liver Transplantation in just 4 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel3.jpg',
          text: 'Purvi (Pushpesh\'s friend) raised ₹ 23,78,790 for Pushpesh\'s  Cancer treatment in just 26 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel4.jpg',
          text: 'Pravin raised ₹ 25,10,000 for his Liver Transplant in just 7 days',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What medical treatments can you raise funds for?',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'heart-surg',
          text: 'Open Heart Surgery',
          invertText: ' ₹6.2 Cr raised by 21 people for their/loved one\'s Open Heart Surgery.',
          text_desc: 'In case of coronary diseases or a malfunctioning heart, opt for corrective heart surgeries by raising funds online for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'kidney-tran',
          text: 'Kidney Transplant',
          invertText: ' ₹8.6 Cr raised by 35 people for their/loved one\'s Kidney Transplant.',
          text_desc: 'In case of kidney failure, you can support the dialysis or transplant by raising funds online for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'nicu',
          text: 'NICU Care',
          invertText: ' ₹10.7 Cr raised by 52 parents for the treatment of under - developed organs of their babies.',
          text_desc: 'Premature babies battle multiple complications due to extremely underdeveloped organs. Pay for the cost of their treatment by raising funds online',
          link: 'Know More',
        },
        {
          icon: 'bone-marrow',
          text: 'Bone Marrow Transplant',
          invertText: ' ₹8.6 Cr raised by 35 people for their/loved one\'s Bone Marrow Transplant.',
          text_desc: 'Once you have a suitable bone marrow contributor, raise funds for the life-saving bone marrow transplant surgery for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'cancer-trt',
          text: 'Cancer Treatment',
          invertText: ' ₹32 Cr raised by 103 people for their/loved one\'s Cancer Treatment.',
          text_desc: 'This five lettered disease comes with chemotherapy, radiation and other expensive treatment options. Support your battle against cancer by raising funds online',
          link: 'Know More',
        },
        {
          icon: 'other',
          text: 'Any other disease?',
          invertText: '',
          text_desc: 'Call Us',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: '',
      style: '',
    },
    section_3: {
      header: 'Why are people choosing medical crowdfunding?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'High cost of treatment',
          text_desc: 'Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small contributions from a large group of people.',
        },
        {
          icon_class: 'asking-money',
          text: 'Asking For Money Isn’t Easy',
          text_desc: 'When in need, asking for help from people and describing financial problems face-to-face can be awkward and inconvenient. Online crowdfunding makes the process of asking for money easier and way more seamless.',
        },
        {
          icon_class: 'emergencies',
          text: 'Emergencies Demand a Prompt Response',
          text_desc: 'When your loved ones are diagnosed with life threatening diseases, it’s overwhelming emotionally as well as financially. Most medical emergencies require the treatment to start at the earliest. By giving you a platform to share your emergency, online crowdfunding helps you gather funds quickly.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Loan Repayment Is Stressful',
          text_desc: 'Getting drowned in personal loans is very common in times of medical emergencies. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding comes without debts.',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from people like you',
      sub_header: 'who benefited from medical crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'I want to start a medical fundraiser. What all do i need?',
          answer: 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.',
        },
        {
          question: 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
          answer: 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.',
        },
        {
          question: 'I want to start raising funds, how do I start a fundraiser on Ketto?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Medical Fundraising & Crowdfunding',
      subheader: 'Online Medical crowdfunding is an alternative method for individuals and organisations to generate funds required for costly medical treatments like open-heart surgeries, NICU care, bone marrow transplant, cancer treatments and any other disease',
      details: [
        {
          h2: 'Medical Bills are a Burden for Many Individuals and Families',
          desc: 'Expenses related to hospital stays, cancer treatments with high- cost chemotherapy routines, and other medicinal costs can be even higher. Treatment costs and necessary living expenses can bring the best of families to the brink of experiencing hard times. Insurance plans are not enough, as policies do not cover everything you need.',
          img_src: '/assets/images/medical-landing/medicalbills.png'
        },
        {
          h2: 'Try Medical Crowdfunding',
          desc: 'Stop worrying about rising medical bills, or debts and start a medical fundraising campaign with Ketto. Ketto is a Crowdfunding Platform based out of India. Crowdfunding is the easiest way to avail support from friends, family and numerous individuals who are waiting to contribute funds.',
          img_src: '/assets/images/medical-landing/trymedical.png'
        },
        {
          h2: 'Start a Medical Fundraiser for Yourself or a Loved One',
          desc: 'With Ketto, you can start a free, easy fundraiser in minutes to cover medical bills and healthcare costs. You can also take on the role of spreading the word and bring in funds when a close friend is diagnosed with unexpected illnesses. Medical fundraising campaigns can give your well-wishers a way to express support when needed.',
          img_src: '/assets/images/medical-landing/startMedFundraiser.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header:
        'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'health',
    metaTitle: 'Medical Crowdfunding - Free Fundraising for Medical Treatment & Expenses',
    metaDesc: 'Medical crowdfunding is a way to raise funds for paying high cost medical bills. Visit Ketto.org to start medical fundraiser for your loved ones or needy people!'
  },
  'animal-fundraising': {
    section_1: {
      header: 'Animal Crowdfunding Is The Easiest Way To Raise Money For Pets And Animals',
      sub_header: 'Need Funds To Pay For Medical Bills/Treatment?',
      bg_image: '/assets/images/medical-landing/banner-animal-crowdfunding.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/animal/images/carousel4.jpg',
          text: 'Sidhi raised ₹ 51000 to get 6 mo 3-legged Simba a prosthetic limb.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/animal/images/carousel1.jpg',
          text: 'Shivani raised ₹ 75,000 to help 200 stray dogs survive Delhi winters.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/animal/images/carousel2.jpg',
          text: 'Shahzia raised ₹ 60000 for fostering and medical expenses of 5 rescued kittens.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/animal/images/carousel3.jpg',
          text: 'Sambhav raised ₹ 171000 for sheltering and medical expenses of ex-working horses and ponies.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What Pet And Animal Causes Need Funds?',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'petsurgeries',
          text: 'PET SURGERIES',
          invertText: 'Start a crowdfunding campaign to cover the cost of your pet’s surgery.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'exp-vet-bills',
          text: 'EXPENSIVE VETERINARIAN BILLS',
          invertText: 'Animal vet bills can get expensive. Crowdfunding on ketto can help you pay high veterinary bills.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'animal-shelter',
          text: 'ANIMAL SHELTERS',
          invertText: 'Raise money through online crowdfunding to support your local animal shelter. ',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'stray-animal-rescue',
          text: 'STRAY ANIMAL RESCUE GROUPS',
          invertText: 'Injured, abandoned animals need help. Support animal rescue groups by starting a crowdfunding campaign on Ketto today!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'animal-kennel',
          text: 'ANIMAL KENNELS AND ADOPTION CENTRES',
          invertText: 'Providing food, shelter and medical care to animals and pets is costly. Crowdfunding helps you cover these costs.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'other-animal-cause',
          text: 'Other Animal Causes',
          invertText: 'There are many animal causes that require urgent funds. Start an animal crowdfunding campaign on Ketto today!',
          text_desc: '',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: 'animal-fundraising',
      style: '',
    },
    section_3: {
      header: 'Why Do Numerous Individuals, NGOs and Organisations Start Crowdfunding For Animals?',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'Cost Of Pet Surgery & Treatment Is Very High',
          text_desc: 'In India, Animals don\'t get medical insurance like us humans. However, when our pets fall ill and require immediate medical care, our savings are not enough to cover the expensive surgery and treatment costs. By starting an Animal Crowdfunding, pet owners can receive small contributions from a large group of people and ensure their pets get the needed medical care.',
        },
        {
          icon_class: 'asking-money',
          text: 'Volunteers Of Animal Shelters Are Unable To Get Adequate Funds',
          text_desc: 'Most animal shelters require constant financial help to provide food and primary healthcare facilities. However, the number of individuals volunteering at shelters is very low. Hence, they have to dedicate every moment to caring for the animals. Starting an animal crowdfunding campaign to support the animal shelter allows them to use social media and the power of the internet to raise awareness and get funding.',
        },
        {
          icon_class: 'emergencies',
          text: 'Rescuing And Rehabilitation Are Expensive',
          text_desc: 'Saving abandoned animals, rescuing injured and helpless animals require different types of equipment. Similarly, providing these animals with a haven and treating their injuries is expensive. Rehabilitation is costly, and the groups that conduct such activities are very few. Therefore, we urge rescue groups to start a crowdfunding campaign for animals on Ketto to ensure all their expenses can be taken care of through fundraising online for such causes.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Animal Conservation Projects',
          text_desc: 'Animal conservation Organisations work tirelessly to protect critical and endangered species, animals, and ecosystems of global importance. They need to collaborate with numerous local communities, government authorities, forest departments and other organisations. These efforts to protect the global ecosystem and animal species require funds. Animal Conservation Organisations and groups can receive contributions online through Ketto’s Online Crowdfunding Platform for Animal Fundraising. ',
        },
      ],
      class: '',
      style: '',
    },
    section_4: {
      header: 'Hear from fellow animal lovers',
      sub_header: 'who benefited from animal crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'vrinda',
          title: 'Vrinda Motasha (for strays) Raised ₹ 53,000',
          whatsapp: '9820337737',
          phone: '9820337737',
          text: 'For Tobler’s 12th birthday, we wanted to do something very special. We wanted him to be a champion for all other dogs and neutering strays was the best way to go. Using crowdfunding, I managed to raise over Rs. 53,000 in just 8 days - it left me thrilled at every step!',
          blog: 'https://www.youtube.com/watch?v=1BMttVJo248',
        },
        {
          profile: 'sudeshna',
          title: 'Sudeshna Guha Roy (for strays) Raised ₹ 82,000',
          whatsapp: '9833555218',
          phone: '9833555218',
          text: 'Through crowdfunding, I got this beautiful opportunity to help Pratima Devi, aka the Dog Lady buy a few cages to keep the injured dogs. With the money, she even renovated her shelter so water doesn’t seep in during monsoons, as a lot of dogs would sleep with her inside the shelter as well.',
          blog: 'https://www.ketto.org/success-stories/Amma-stray-dogs',
        },
        {
          profile: 'nichint',
          title: 'Nichint Sohal (For Chamcham) Raised ₹ 1,45,000',
          whatsapp: '9821441512',
          phone: '9821441512',
          text: 'Initially when we were doing Chamcham’s treatment, it was all small amounts from our own pockets. Later we decided to open up a fundraiser on Ketto. Everyone was very generous. It (funds) just kept going higher and higher. Within 45 minutes, we managed to cross our goal!',
          blog: 'https://www.facebook.com/ketto.org/videos/1183029631750140/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image:
        'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'Which animals can I raise funds for?',
          answer: 'Be it a stray dog, cat, cow or even a crow - you can raise for any animal in need.',
        },
        {
          question: 'What causes can I raise funds for?',
          answer: 'You can raise funds for sterilisation of animals, feeding animals, their medical treatment, adoption, or to support an NGO of your choice. If you want to raise funds for something else, we’ll be more than happy to assist you.',
        },
        {
          question: 'My NGO is not associated with Ketto, can I still raise funds for their project?',
          answer: 'Absolutely! We’ll be more than happy to help them raise funds so their project can come to life.',
        },
        {
          question: 'I have more questions, who do I write to?',
          answer: 'You can write to info@ketto.org. Know people who are always trying their best to help animals around them? We\'re sure you have at least one on your list - share it with them!',
        },
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: '',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Animal Fundraising and Crowdfunding',
      subheader: 'Crowdfunding and Fundraising for Animal-related causes is an alternative method for individuals, NGOs, and corporate organisations to collect funds for costly medical treatments of pets and animals. Similarly, rescue organisations, animal shelters, and animal adoption groups can receive funds from numerous individuals to sustain daily expenses, including providing nutritious food, adequate hygiene and daily veterinary care.',
      details: [
        {
          h2: 'Veterinary Expenses and Pet Surgeries Can Be Very Expensive for Many Individuals and NGOs.',
          desc: 'The pain and suffering that pets and animals experience is heart-wrenching. The sight of these animals suffering makes everyone want to provide them with care and assistance to relieve this pain. Unfortunately, the cost of surgeries and vet bills are very expensive. The infrastructure is not adequate. Numerous individuals, NGOs and corporate organisations constantly seek funds to support these animals. Ketto\'s Animal Fundraising and Animal Crowdfunding can Help!',
          img_src: '/assets/images/medical-landing/puppy-1.png'
        },
        {
          h2: 'Use Animal Crowdfunding.',
          desc: 'Don\'t be disheartened about the recurring expenses and being unable to provide the basic needs of these loving animals and pets. Instead, Start an Animal Crowdfunding Campaign with Ketto Today! Ketto is rated the Ketto is a Crowdfunding Platform based out of India In Asia for Animal Fundraising. Animal Crowdfunding is the simplest and quickest way to support individuals who want to assist such animal fundraising causes. Similarly, friends, family and numerous corporate entities are waiting to contribute funds to animal-related charities and fundraisers on Ketto\'s Online Crowdfunding Platform.',
          img_src: '/assets/images/medical-landing/ketto-square.png'
        },
        {
          h2: 'Start An Animal Fundraising Campaign For Pet Or Any Animal.',
          desc: 'On Ketto, you can Start A Fundraiser Campaign in minutes to assist or pay for vet bills and pet surgery costs. You can also help bring in funds by sharing ongoing animal campaigns that you feel require mentioning in your friend circles and corporate network. Animal and Pet Fundraising Campaigns can give countless individuals a means to express their support in a monetary form.',
          img_src: '/assets/images/medical-landing/startAnimalFundraising.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'animal',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/animal/images/animal_sprite.png\')',
    cause: 'animals',
    metaTitle: 'Animal Crowdfunding – Fundraising for Stray Animals & NGOs',
    metaDesc: 'With Ketto.org you can start crowdfunding campaign to raise funds for stray animals and NGOs who are working towards wellbeing for animals such as dogs, cats, cows and more.',
    test: 'test',
  },
  'transplant-crowdfunding': {
    section_1: {
      header: 'Fundraising for Transplant Treatment with Ketto',
      sub_header: 'Now with 0% platform fees*',
      bg_image: '/assets/images/medical-landing/banner-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3178/image/e312143c84a64811c5f8d272e24d0dbdf89f3350.png',
          text: 'Anthony (Adrian\'s father) raised ₹ 21,00,000 for Adrian\'s  Kidney and Pancreas Transplant in just 22 days.'
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3177/image/f7294cf01458c2d331d3e9ea35b27692140896b5.png',
          text: 'Varinder (Kulbir\'s cousin) raised ₹ 18,82,189 for Kulbir\'s Liver Transplant in just 25 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel4.jpg',
          text: 'Pravin raised ₹ 25,10,000 for his Liver Transplant in just 7 days',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/carousel2.jpg',
          text: 'Rajshekhar Nadar (Karthi\'s father) raised ₹ 25,85,870 for Karthi\'s Liver Transplantation in just 4 days.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'Friends, family members, or colleagues who are struggling to pay for a transplant can start a Transplant Crowdfunding Campaign to:',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'help-out-family',
          text: 'Help out a family member or a friend',
          invertText: ' ₹6.2 Cr raised by 21 people for their/loved one\'s Open Heart Surgery.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'money-bag',
          text: 'Fund your own treatment',
          invertText: ' You can start a fundraiser to support your own medical cost and independently take care of your medical treatment without debt',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'home-care',
          text: 'Raise funds for at-home care',
          invertText: 'If a patient or a senior citizen needs medical care at home, you can help them by raising money for day nurses and at-home doctor visits.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'organ-transplant',
          text: 'Get Money for Organ Transplant',
          invertText: 'You can fund organ transplant costs by raising money online to help save yourself or a loved one.',
          text_desc: 'Once you have a suitable bone marrow contributor, raise funds for the life-saving bone marrow transplant surgery for yourself or a loved one',
          link: 'Know More',
        },
        {
          icon: 'daily-prescription',
          text: 'Daily Prescriptions and Care',
          invertText: 'For adults and senior citizens suffering from medical conditions that need daily medication or doctor visits, you can raise money for your day-to-day medical costs.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'other',
          text: 'And more!',
          invertText: 'Talk to a Ketto Adviser!',
          text_desc: 'Call Us',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: 'transplant',
      style: '',
    },
    section_3: {
      header: 'Why is Ketto India’s Most Used Online Crowdfunding Platform to Raise Funds for Transplants?',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'Payout',
          text_desc: 'You shouldn’t have to wait to get your funds. Ketto ensures you can withdraw funds collected at any point during your fundraiser\'s progress.',
        },
        {
          icon_class: 'asking-money',
          text: 'International Payment Support',
          text_desc: 'Reach out to like-minded students and peers abroad. At Ketto, contributions are accepted in multiple currencies from around the world.',
        },
        {
          icon_class: 'emergencies',
          text: '24*7 Support',
          text_desc: '24*7 on-call assistance, WhatsApp, Email, SMS, and Personalised Instant Chatting Interface.',
        },
        {
          icon_class: 'transplant-call-icon',
          text: 'Dedicated Fundraiser Expert',
          text_desc: 'A dedicated fundraiser expert is appointed; they will guide you through your fundraising journey and assist you with all your fundraising queries.',
        },
      ],
      class: 'transplant',
      style: '',
    },
    section_4: {
      header: 'Millions of people have successfully raised funds on Ketto for their cause.',
      sub_header: 'Hear what some of our successful campaigners have to say!',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'How I can start Transplant Crowdfunding?',
          answer: 'Starting a fundraiser on Ketto takes just 3 minutes, and signing up is free*. Just sign up, fill in details of what you need money for, and hit submit.',
        },
        {
          question: 'What all documents do I need to submit?',
          answer: 'All campaigners undergo a KYC verification based on the submitted legal identity proofs and other supporting documents. PAN card Address proof - Aadhar card (front and back), Passport (first and last page), Election card (front and back), or Driver\'s license.',
        },
        {
          question: 'How much can I raise for my Transplant?',
          answer: 'You can reach out to our support team to get advice on much you should raise for your Transplant.',
        },
        {
          question: 'What is the withdrawal process?',
          answer: 'To withdraw funds in your bank account, you must submit your bank account details and documents per Ketto\'s requirements.',
        },
        {
          question: 'I have more questions regarding fundraising for Transplants; whom do I write to?',
          answer: 'You can write to info@ketto.org. Just drop your queries and get answers to your doubts.'
        }
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Does Crowdfunding for Transplant on Ketto Offer?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: '0% Platform Fee*. Starting a fundraiser on Ketto is free.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'Instantly Withdraw Of Funds without any hassle directly to your bank account.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'Amount raised after the transactional processing fee is yours to keep.',
        },
        {
          icon_class: 'multiple-people-icon',
          text: 'Multiple people can manage and fundraise for your cause.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accept contributions from all cards, net banking, UPI, and online wallets from anywhere.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Receive instant updates of fundraiser\'s progress on a real-time dashboard.',
        },
      ],
      class: 'transplant',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'Raise Funds for Organ Transplants',
      subheader: 'The term “Transplant Crowdfunding” defines itself as a process of raising money by seeking small contributions from several people for an organ transplant.',
      details: [
        {
          h2: 'What is Transplant Crowdfunding in India?',
          desc: 'Crowdfunding can help you raise funds for a surgery that you wouldn\’t otherwise have the funds for. For example, if you\'re raising money on Ketto to pay for your heart transplant, this helps spare you a lot of worries over paying for the operation and additional costs. It also means that you won\'t be worried about money while focusing on the recovery at hand.',
          img_src: '/assets/images/medical-landing/transplant-doctors.png'
        },
        {
          h2: 'Why Start a Crowdfunding Campaign for Transplant with Ketto?',
          desc: 'Costs pile up when you don\'t just have to pay for the surgery itself.  The evaluation required, follow-up visits, necessary medications that must be taken regularly, and time away from work combined all add up quickly.  The total cost can vary depending on each person’s circumstances and where they get their health care.  Many people have to travel to a transplant center and stay in the area, leading to additional costs for transport, a place to stay, loss of income for time off work, and food during the recovery period after surgery. Many people also need alternative treatments or transportation.',
          img_src: '/assets/images/medical-landing/transplant-contribute.png'
        },
        {
          h2: 'Who can Start A Transplant Crowdfunding Campaign on Ketto?',
          desc: 'You can help out a friend, family member, or colleague struggling to pay for a kidney, heart, or liver transplant. You can also start a fundraiser for yourself if you are struggling with paying for a kidney, heart, or liver transplant and would like to independently take care of your medical treatment without taking on debt. ',
          img_src: '/assets/images/medical-landing/trymedical.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'transplant',
    metaTitle: 'Transplant Fundraising – Fundraising for Transplant Treatment in India',
    metaDesc: 'Fundraising for transplant made easy with Ketto! Get funding for organs transplant treatments through transplant crowdfunding.',
    keywords: 'Transplant Fundraising, Transplant Crowdfunding',
  },
  'sports-crowdfunding': {
    section_1: {
      header: 'Launch a Winning Sports Fundraising Campaign on Ketto',
      sub_header: 'Now with 0% platform fees*',
      bg_image: '/assets/images/medical-landing/sports-bg.png',
      background_attachment: 'fixed',
      background_color: '#f5f5f5',
      data_images: [
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3175/image/7906ac7eed9fd1d5f3df76913878a4febc2d5077.png',
          text: 'Ice Hockey Association of India raised ₹ 32,34,976 for Women\'s Ice Hockey Team in just 10 days.'
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3174/image/ed2615a2b25dcc07843f570d7f2cb8b8026b9659.png',
          text: 'Apurva Kothari raised ₹ 19,01,300 for India Frisbee Team in just 57 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3176/image/d47f6984cee4d371e646e1b8853fbb4663a96e74.png',
          text: 'Star Sports raised ₹ 51,84,958 for Yuwa India Trust in just 45 days.',
        },
        {
          url: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/3000/3173/image/fc0b4146c878ee7db09d52526344e07c55a0ee69.png',
          text: 'Abhishek Srinivas raised ₹ 11,89,818 for India Frisbee Team in just 19 days.',
        },
      ],
      class: '',
      style: '',
    },
    section_2: {
      header: 'What can you raise funds for?',
      sub_header: '',
      bg_image: '',
      link: 'true',
      data_images: [
        {
          icon: 'jersey',
          text: 'Tournament',
          invertText: 'Start Sports Crowdfunding and raise funds for signage, tournament guides, payment to volunteers, staff, gear sales, golf carts, field lining, tents, tables and chairs, and entertainment.!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'badminton',
          text: 'Team Trips',
          invertText: 'Raise money to assist the financial needs of sports team trips like airfare, hotel bookings, food costs, inter-city transit, etc.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'vip-sport-pass',
          text: 'Equipment purchases',
          invertText: 'Team & individual sports equipment, uniforms & playing fields cost a large amount of money. Start crowdfunding with Ketto to raise funds for sports equipment.',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'trophy',
          text: 'Uniforms and jerseys',
          invertText: 'The cost of sports uniforms and jerseys for an entire team can cost thousands of rupees. Try Ketto crowdfunding for sports! Start a crowdfunding campaign and request contributions from fans, friends, and family!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'globe-sport',
          text: 'Membership fees or monthly dues',
          invertText: 'Start raising more money for club memberships through sports crowdfunding today!',
          text_desc: '',
          link: 'Know More',
        },
        {
          icon: 'other',
          text: 'And more!',
          invertText: 'Talk to a Ketto Adviser!',
          text_desc: 'Call Us',
          link: 'Talk to Ketto Advisor',
          click: 'true',
        },
      ],
      class: 'sports',
      style: '',
    },
    section_3: {
      header: 'Why are Athletes and Coaches choosing sports crowdfunding?',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      data_images: [
        {
          icon_class: 'high-cost',
          text: 'High Cost Of Equipment & Maintenance',
          text_desc: 'Buying new sports equipment is expensive. Maintenance costs are recurring and create a tremendous financial burden on the athletes and their coaches. Savings are not enough to cover the expensive bills. Sports crowdfunding helps you pay these expensive bills and purchase new equipment.',
        },
        {
          icon_class: 'dumbell-sports',
          text: 'Sports equipment, nutrition & training requires money',
          text_desc: 'Athletes, coaches, and trainers pursue their dream of winning a gold medal. Team fees, equipment costs, and travelling fees become a financial burden. Costs of living such as rent, food, gas, etc., increase this burden. Crowdfunding on Ketto helps you gather required funds quickly.',
        },
        {
          icon_class: 'asking-money-sports',
          text: 'Asking For Money Isn’t Easy',
          text_desc: 'When in need, asking for help from people, and describing financial problems face-to-face can be awkward and inconvenient for teams, athletes, and coaches. Online sports crowdfunding makes the process of asking for money easier and seamless.',
        },
        {
          icon_class: 'loan-repayment',
          text: 'Loan Repayment Is Stressful',
          text_desc: 'Getting drowned in personal loans is a common phenomenon in families of sportsmen and women. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding for sports-related expenses comes without debts.',
        },
      ],
      class: 'sports',
      style: '',
    },
    section_4: {
      header: 'Hear from people like you',
      sub_header: 'who benefited from sports crowdfunding',
      bg_image: 'med-bg',
      data_images: [
        {
          profile: 'deepak-patil',
          title: 'Constable Deepak Patil, Mumbai Police (Patient) Raised ₹ 9,57,401',
          facebook: 'https://www.facebook.com/profile.php?id=100003190062105',
          phone: '8108816662',
          text: 'My liver transplant was stuck because my family didn\'t have funds to afford it. It\'s only because I knocked on Ketto\'s door that I\'m healthy today. A big thank you to each and every one who gave me money. I wouldn\'t be alive without you.',
          blog: 'http://blog.ketto.org/without-a-transplant-deepak-will-die-helpless-father-appeals-for-funds-for-sons-surgery/',
        },
        {
          profile: 'nitya',
          title: 'Nitya (Karthi\'s mother) Raised ₹ 25,85,870',
          phone: '9833689485',
          text: 'मेरे कार्थी का ऑपरेशन सिर्फ लोगों के फंड्स की वजह से हुआ. कितने सारे लोगों ने मेरे बच्चें को बिना किसी अपेक्षा के पैसे दिए. मेरे बच्चें की जान बचाने का बहुत बहुत शुक्रिया. केट्टो का इसमें बहुत योगदान रहा. मैं इस मदद के लिया सदा कृतज्ञ रहूंगी.',
          blog: 'http://blog.ketto.org/help-us-save-karthi/',
        },
        {
          profile: 'purvi',
          title: 'Purvi (Pushpesh\'s friend) Raised ₹ 23,78,790',
          phone: '9885018920',
          text: 'We would urge anyone and everyone to extend their helping hand in betterment of a person who will continuously make this world a better place. Any contribution you make, big or small, will put us in your debt forever.',
          blog: 'http://blog.ketto.org/help-pushpesh-fight-blood-cancer/',
        },
      ],
      class: '',
      style: '',
    },
    section_5: {
      header: 'Frequently Asked Questions',
      sub_header: '',
      bg_image: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/design/pattern.png\') center center fixed',
      faqs1: [
        {
          question: 'What is Ketto Crowdfunding?',
          answer: 'Ketto is the world’s leading crowdfunding platform for athletes, teams, and clubs.',
        },
        {
          question: 'Who is Ketto for?',
          answer: 'Ketto is for individuals, teams, clubs, events, and even sporting entrepreneurs.',
        },
        {
          question: 'Why use Ketto?',
          answer: 'Because our crowdfunding platform allows all individuals and teams to raise funds quickly and efficiently using the best tools available.',
        },
        {
          question: 'Is Ketto Crowdfunding secure?',
          answer: 'We employ the best secure payment encryption technology available. Contributor’s online payments are safe and your money is stored securely until your campaign is complete.',
        },
        {
          question: 'What does it cost to raise money on Ketto?',
          answer: 'Ketto Charges 0% Platform Fees*.'
        },
        {
          question: 'Can anybody create a Sports funding campaign?',
          answer: 'Any individual for themselves or for another, or an individual on behalf of a club or team can use Ketto’s to start a sports fundraising Campaign.'
        },
        {
          question: 'How do I know when a supporter makes a contribution?',
          answer: 'You will receive an alert from us each time a contribution is made plus it will also appear on your campaign page.'
        }
      ],
      class: '',
      style: '',
    },
    section_6: {
      header: 'What Ketto Offers?',
      sub_header: '',
      bg_image:
        'med-offers-bg',
      data_images: [
        {
          icon_class: 'free-icon',
          text: 'Starting a fundraiser on Ketto is absolutely free.',
        },
        {
          icon_class: 'offer-icon',
          text: '24x7 assistance from dedicated fundraiser managers throughout your fundraising journey.',
        },
        {
          icon_class: 'currencies-icon',
          text: 'We accept contributions in multiple currencies from anywhere in the world.',
        },
        {
          icon_class: 'withdraw-icon',
          text: 'You can withdraw your funds at any point during the course of your fundraiser.',
        },
        {
          icon_class: 'instant-icon',
          text: 'Get instant updates on your fundraiser\'s progress on a real-time dashboard.',
        },
        {
          icon_class: 'credit-icon',
          text: 'Accepts contributions all cards, netbanking, UPI and online wallets.',
        },
      ],
      class: 'sports',
      style: '',
    },
    section_7: {
      header: 'Active Fundraisers',
      sub_header: '',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_8: {
      header: 'Have any query or Need help?',
      sub_header: 'Receive a call from Ketto Advisor',
      bg_image: '',
      data_images: [
        {
          url: '',
          text: '',
        },
      ],
      class: '',
      style: '',
    },
    section_9: {
      header: 'What is Sports Crowdfunding?',
      subheader: 'It is essential to any athlete or sportsperson trying to become the best they can be in what they do. However, unfortunately, it isn’t always easy for them to get the funds they need for training, equipment, and overall development.',
      details: [
        {
          h2: 'Equipment, Nutrition & Coaching costs are a Burden for Many Individuals and Families of Athletes',
          desc: 'Participation in local, state, and international sports competitions are costly. With the continuously shrinking of monetary funds from numerous sports & governing bodies, the expense provided by family and friends is exhausted quickly.',
          img_src: '/assets/images/medical-landing/sports-cause-1.png'
        },
        {
          h2: 'Try Sports Crowdfunding with Ketto',
          desc: 'Through Sports Crowdfunding, we at Ketto aim to provide athletes, parents, friends, and sports governing bodies a unique platform that can empower athletes while simultaneously allowing you to be part of their journey and share their dreams as well as making sure your money is going towards a great cause!',
          img_src: '/assets/images/medical-landing/sports-cause-2.png'
        },
        {
          h2: 'Start a Sports Crowdfunding Campaign for Yourself or a Deserving Athlete/Sportsmen',
          desc: 'Rather than look for sponsors via traditional channels, why not go online through Ketto Crowdfunding and reach a massive audience! It’s simple; create your crowdfunding campaign and let everyone know about it. We will provide you with a page where you can tell your story, and display photos and videos about what inspired you to do this in the first place. This will give supporters and people a chance to get to know who you are as an athlete. It’s a great way to connect with them, take them on the journey with you, and share your passion! By using Ketto’s Crowdfunding and fundraising platform, we will also enhance your profile and increase your fanbase. Start your Sports Fundraising Campaign on Ketto today!',
          img_src: '/assets/images/medical-landing/sports-cause-3.png'
        }
      ]
    },
    formData: {
      header: 'Need funds to pay for medical bills/treatment?',
      sub_header: 'Our personal fundraiser expert is waiting to get you started!',
    },
    pageType: 'medical',
    sprite: 'url(\'https://d1vdjc70h9nzd9.cloudfront.net/landing_page/cause/assets/medical/images/medical_sprite.png\')',
    test: 'test',
    cause: 'sports',
    metaTitle: 'Sports Fundraising - Fundraising for Sports Made Easy',
    metaDesc: 'Start your Sports fundraising campaign with Ketto to raise funds for your sports teams, clubs, event, or sporting activity.',
    keywords: 'sports fundraising, fundraising for sports',
  },
};
